import React from 'react';
import RoomDependentWrapperPage from '@common/components/Room/RoomSelectors/RoomDependentWrapperPage';
import Stack from '@mui/material/Stack';
import RoomCleaningConfiguration from '@common/components/Room/Configuration/RoomCleaningConfiguration';
import RoomButtonConfiguration from '@common/components/Room/Configuration/RoomButtonConfiguration';
import GeneralMapConfigurations from '@common/components/Room/Configuration/GeneralMapConfigurations';

const MapConfigurationPage: React.FC = () => {
  return (
    <React.Fragment>
      <RoomDependentWrapperPage scrollable>
        <Stack spacing={2} p={0.3} sx={{ width: '100%', alignItems: 'center' }}>
          <RoomCleaningConfiguration />
          <RoomButtonConfiguration />
          <GeneralMapConfigurations />
        </Stack>
      </RoomDependentWrapperPage>
    </React.Fragment>
  );
};

export default MapConfigurationPage;
